module.exports = __webpack_public_path__ + "static/media/1.15_preview.029b85d0.png";